import axios from "axios";
import apiUrlOne from "../../../utils.js/Config";

/* Fetch all menus permissions */
export const getAllMenusPermissions = async (page = 1, limit = 10, search = "") => {
    try {
        const params = { page };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        if (search) params.search = search;
        const response = await axios.get(`${apiUrlOne}/menus`, {
            params,
            headers: { 'accept': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching menus permissions:", error);
        throw error;
    }
};

/* Create menu */
export const createMenu = async (menuData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/menus`, menuData, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating menu:", error);
        throw error;
    }
};

/* Update menu */
export const updateMenu = async (id, menuData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/menus/${id}`, menuData, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating menu with ID ${id}:`, error);
        throw error;
    }
};

/* Delete menu */
export const deleteMenu = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/menus/${id}`, {
            headers: {
                'accept': '*/*',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error deleting menu with ID ${id}:`, error);
        throw error;
    }
};

/* Get menu by role ID (for edit) */
export const getMenuById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/menus/${id}`, {
            headers: { 'accept': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching menu by role ID:", error);
        throw error;
    }
};

/* Get menus by role ID */
// curl -X GET http://localhost:8000/api/v1/menus/get-menu-groups \
//   -H "Authorization: Bearer <your_token>"
export const getMenuByRoleId = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/menus/get-menu-by-role-id`, {
            // const response = await axios.get(`${apiUrlOne}/menus/get-menu-groups`, {
            headers: { 'accept': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching menus by role ID:", error);
        throw error;
    }
};


/* Update menu permission */
export const updateMenuPermission = async (permissionData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/menus/update-menu-permission`, permissionData, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating menu permission:", error);
        throw error;
    }
};

/* Get all permissions by role ID */
export const getPermissionsByRoleId = async (roleId, page = 1, limit = 10, search = "") => {
    try {
        const params = { page };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        if (search) params.search = search;
        const response = await axios.get(`${apiUrlOne}/menus/get-all-permission-by-role-id/${roleId}`, {
            params,
            headers: { 'accept': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching permissions for role ID ${roleId}:`, error);
        throw error;
    }
};

/* Get menu permissions by role ID and menu ID */
export const getMenuPermissionsByRoleAndMenu = async (roleId, menuId) => {
    try {
        const response = await axios.post(`${apiUrlOne}/menus/get-menu-permissions`, {
            roleId, menuId
        }, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching menu permissions:", error);
        throw error;
    }
};

/* Get available modules for dropdown */

// export const getAvailableModules = async () => {
//     try {
//         const response = await axios.get(`${apiUrlOne}/menus/get-available-modules`, {
//             headers: { 'accept': 'application/json' }
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching available modules:", error);
//         throw error;
//     }
// };
